import http from './api'

const route = 'app/devolucao/'

export default {
  showGraficosDadosDevolucao: (dataInicial, dataFinal, empresaSelect, vendedores, cidades, areas, tipoDevolucao, motivoDevolucao, tokencontrato, receita, segmento, rede, categoria, promotor) => {
    return http.post(route + 'showGraficosDadosDevolucao', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      cidades: cidades,
      areas: areas,
      tipoDevolucao: tipoDevolucao,
      motivoDevolucao: motivoDevolucao,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
      rede: rede,
      categoria: categoria,
      promotor: promotor,
    })
  },

  showGraficoDevolucaoPropria: (dataInicial, dataFinal, empresaSelect, vendedores, cidades, areas, tipoDevolucao, motivoDevolucao, tokencontrato, receita, segmento) => {
    return http.post(route + 'showGraficoDevolucaoPropria', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      cidades: cidades,
      areas: areas,
      tipoDevolucao: tipoDevolucao,
      motivoDevolucao: motivoDevolucao,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showDadosDevolucaoPropria: (dataInicial, dataFinal, empresaSelect, vendedores, cidades, areas, tipoDevolucao, motivoDevolucao, tokencontrato, receita, segmento) => {
    return http.post(route + 'showDadosDevolucaoPropria', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      cidades: cidades,
      areas: areas,
      tipoDevolucao: tipoDevolucao,
      motivoDevolucao: motivoDevolucao,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showGraficoDevolucaoImpropria: (dataInicial, dataFinal, empresaSelect, vendedores, cidades, areas, tipoDevolucao, motivoDevolucao, tokencontrato, receita, segmento) => {
    return http.post(route + 'showGraficoDevolucaoImpropria', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      cidades: cidades,
      areas: areas,
      tipoDevolucao: tipoDevolucao,
      motivoDevolucao: motivoDevolucao,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },

  showDadosTabelaDevolucaoImpropria: (dataInicial, dataFinal, empresaSelect, vendedores, cidades, areas, tipoDevolucao, motivoDevolucao, tokencontrato, receita, segmento) => {
    return http.post(route + 'showDadosTabelaDevolucaoImpropria', {
      dataInicial: dataInicial,
      dataFinal: dataFinal,
      empresas: empresaSelect,
      vendedores: vendedores,
      cidades: cidades,
      areas: areas,
      tipoDevolucao: tipoDevolucao,
      motivoDevolucao: motivoDevolucao,
      tokenContrato: tokencontrato,
      receita: receita,
      segmento: segmento,
    })
  },
}
